module.exports = __webpack_public_path__ + "static/media/tour-time-red.f3d7eb9b.svg";